/**
 * Navigation configuration for Seva module
 * Uses translation keys (labelKey, titleKey) instead of direct strings
 * Transform with useNavigation() composable to get localized labels
 */
export const sevaNavSections = [
  // ── Overview ──
  {
    items: [
      {
        id: 'dashboard',
        labelKey: 'nav.dashboard',
        icon: 'dashboard',
        path: '/',
      },
    ],
  },
  // ── People (who gives + who receives) ──
  {
    titleKey: 'nav.people',
    items: [
      {
        id: 'patrons',
        labelKey: 'nav.patrons',
        icon: 'heart',
        path: '/patrons',
      },
      {
        id: 'beneficiaries',
        labelKey: 'nav.beneficiaries',
        icon: 'users',
        path: '/beneficiaries',
      },
      {
        id: 'commitments',
        labelKey: 'nav.commitments',
        icon: 'calendar',
        path: '/commitments',
      },
    ],
  },
  // ── Receipts ──
  {
    titleKey: 'nav.receiptsSection',
    items: [
      {
        id: 'receipts',
        labelKey: 'nav.receipts',
        icon: 'file-text',
        path: '/receipts',
      },
      {
        id: 'new-receipt',
        labelKey: 'nav.newReceipt',
        icon: 'plus-circle',
        path: '/receipts/new',
      },
    ],
  },
  // ── Money (in + out) ──
  {
    titleKey: 'nav.money',
    items: [
      {
        id: 'donations',
        labelKey: 'nav.donations',
        icon: 'gift',
        path: '/donations',
      },
      {
        id: 'expenses',
        labelKey: 'nav.expenses',
        icon: 'receipt',
        path: '/expenses',
      },
      {
        id: 'bank-accounts',
        labelKey: 'nav.bankAccounts',
        icon: 'wallet',
        path: '/bank-accounts',
      },
      {
        id: 'transfers',
        labelKey: 'nav.transfers',
        icon: 'arrows',
        path: '/transfers',
      },
    ],
  },
  // ── Programs (what we do + track) ──
  {
    titleKey: 'nav.programsSection',
    items: [
      {
        id: 'programs',
        labelKey: 'nav.programs',
        icon: 'layers',
        path: '/programs',
      },
      {
        id: 'activity-log',
        labelKey: 'nav.activityLog',
        icon: 'calendar',
        path: '/activity-log',
      },
    ],
  },
  // ── Reports & Compliance ──
  {
    titleKey: 'nav.reports',
    items: [
      {
        id: 'receipt-payment',
        labelKey: 'nav.receiptPayment',
        icon: 'file-text',
        path: '/reports/receipt-payment',
      },
      {
        id: 'form-10be',
        labelKey: 'nav.form10be',
        icon: 'file-text',
        path: '/reports/form-10be',
      },
      {
        id: 'income-expenditure',
        labelKey: 'nav.incomeExpenditure',
        icon: 'file-text',
        path: '/reports/income-expenditure',
      },
      {
        id: 'balance-sheet',
        labelKey: 'nav.balanceSheet',
        icon: 'file-text',
        path: '/reports/balance-sheet',
      },
      {
        id: 'integrity-check',
        labelKey: 'nav.integrityCheck',
        icon: 'shield',
        path: '/reports/integrity-check',
      },
      {
        id: 'bank-reconciliation',
        labelKey: 'nav.bankReconciliation',
        icon: 'refresh-cw',
        path: '/bank-reconciliation',
      },
    ],
  },
  // ── Communication ──
  {
    titleKey: 'nav.communication',
    items: [
      {
        id: 'messages',
        labelKey: 'nav.messages',
        icon: 'message',
        path: '/messages',
      },
    ],
  },
  // ── Settings ──
  {
    titleKey: 'nav.settingsSection',
    items: [
      {
        id: 'settings',
        labelKey: 'nav.settings',
        icon: 'settings',
        path: '/settings',
      },
      {
        id: 'receipt-types',
        labelKey: 'nav.receiptTypes',
        icon: 'layers',
        path: '/settings/receipt-types',
      },
      {
        id: 'funds',
        labelKey: 'nav.funds',
        icon: 'target',
        path: '/settings/funds',
      },
      {
        id: 'membership-tiers',
        labelKey: 'nav.membershipTiers',
        icon: 'star',
        path: '/settings/membership-tiers',
      },
    ],
  },
]
